// extracted by mini-css-extract-plugin
export default {"title":"AU2kP","actions":"KKS6w","action":"RX37D"};